import { Provider} from "react-redux";
import { store } from "./redux/store";
import { Toaster } from "react-hot-toast";
import { Suspense, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { AbilityContext } from "./utility/context/Can";
import { ThemeContext } from "./utility/context/ThemeColors";
import userManager, { loadUserFromStorage } from "./services/userService";
import Routere from "./router/Router";
import ability from "./configs/acl/ability";
import AuthProvider from "./utility/authProvider";
import ErrorBoundary from "./views/errorBoundary";
import ResendModal from "./components/resendModal";
import CsvConverter from "./components/csvConverter";
import ErrorModal from "./@core/auth/handleErrorModal";
import FiltersSideBar from "./components/filterSideBar";
import Spinner from "./@core/components/spinner/Fallback-spinner";
import FiltersSideBarAttendees from "./components/filterSideBarAttendees";
import "prismjs";
import "./styles.scss";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";
import "prismjs/components/prism-jsx.min";
import "./@core/components/ripple-button";
import "prismjs/themes/prism-tomorrow.css";
import "@styles/react/libs/toastify/toastify.scss";
import "./@core/assets/fonts/feather/iconfont.css";
import "react-perfect-scrollbar/dist/css/styles.css";

const App = () => {
  useEffect(() => {
    loadUserFromStorage(store);
  }, []);

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <AuthProvider userManager={userManager} store={store}>
          <Suspense fallback={<Spinner />}>
            <AbilityContext.Provider value={ability}>
              <ThemeContext>
                <Routere />
                <ToastContainer newestOnTop />
                <ErrorModal />
                <ResendModal />
                <FiltersSideBar />
                <FiltersSideBarAttendees />
                <CsvConverter />
                <Toaster />
              </ThemeContext>
            </AbilityContext.Provider>
          </Suspense>
        </AuthProvider>
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
